import React from 'react';
import {Outlet} from "react-router-dom";

import css from './MenuPage.module.css';
import {TitleMenuMenu} from "../../components/menuSection";


const MenuPage = () => {
    return (
        <section className={css.wrap}>
            <section className={css.menuBlock}>
                <TitleMenuMenu/>
            </section>

            <section className={css.outletBlock}>
                <Outlet/>
            </section>
        </section>
    );
};

export {MenuPage};